const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout/companies/$id')({
  preload: false,
  beforeLoad: async ({
    params,
    matches
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (lastMatch.id.endsWith(`/companies/${params.id}`)) {
      redirect({
        to: '/companies/$id/general',
        params: {
          id: params.id
        },
        throw: true,
        replace: true
      });
    }
  },
  loader: async () => {
    return {
      crumb: t('NAVIGATION.COMPANIES'),
      to: '/companies'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});